import { storeApi } from '@/api';
import { field, embed, } from '@/lib/query-parameter/resource';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import * as filterOption from '@/lib/query-parameter/filter';
import { injectSortParamHelper } from '@/lib/query-parameter/sortby';
import PaginationOutput from '@/helpers/PaginationOutput';
import { timeZoneCode } from '@/constants/global';
import { changeStartEndStringTimeZone } from '@/utils/index';
const { injectFilterParamHelper, include, } = filterOption;
export default {
    /**
     * 가상 계좌 조회
     */
    async getVirtualBanksByStore({ storeId, }) {
        const response = await storeApi.getVirtualBanksByStore({
            storeId,
        });
        return response.data;
    },
    async getStoreList({ filters = [], pageNumber = 1, pageSize = 10_000, }) {
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addFields(field('distributorId', 'code', 'name', 'addChargeApplyYn', 'addDeliveryCharge', 'addDeliveryChargeRate', 'addCookingTime', 'deliveryWorkYn', 'useYn'));
        injectFilterParamHelper(params, filters);
        const response = await storeApi.getStoreList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getStoreAdjustment({ filters = [], pageNumber = 1, pageSize = 10_000, }) {
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addFields(field('distributorId', 'code', 'name', 'addChargeApplyYn', 'addDeliveryCharge', 'addDeliveryChargeRate', 'addCookingTime', 'deliveryWorkYn', 'useYn'));
        injectFilterParamHelper(params, filters);
        const response = await storeApi.getStoreList(params.build());
        return response.data;
    },
    async getStoreDetail(storeId = '') {
        if (!storeId) {
            console.log('[getStoreDetail] storeId missing');
        }
        const params = new QueryParameterBuilder()
            .addEmbeds(embed('hub', 'worker_fee_per_store_group', 'goods_price_surcharge_info'));
        const response = await storeApi.getStore(storeId, params.build());
        return response.data;
    },
    postOperationSetting(formDto) {
        return storeApi.postOperationSetting(formDto);
    },
    async getStoreManagementList({ filters = [], sortOption = [], pageNumber = 1, pageSize = 100, hubId, }) {
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addFields(field('useYn', 'name', 'restDays', 'workingTime', 'phone', 'ceoName', 'ceoPhone', 'addressDong', 'addressLi', 'addressJibun', 'addressRoad', 'addressBuildingNumber', 'addressBuildingName', 'addressDetail', 'hubId', 'code', 'vatRate', 'deliveryPayFlag', 'endDeliveryCount', 'monthDeliveryCount', 'deliveryManagementFeePerOrder', 'deliveryManagementFeeRatePerOrder', 'deliveryFeeMonthly', 'deliveryFeeMonthlyDay', 'depositBaromoney', 'baromoney', 'createdAt'))
            .addEmbeds(embed('hub'));
        if (hubId) {
            params.addFilters(include('hubId', hubId));
        }
        injectFilterParamHelper(params, filters);
        injectSortParamHelper(params, sortOption);
        const response = await storeApi.getStoreList(params.build());
        return response.data;
    },
    // 발주허브의 상점 리스트 조회
    async getHubStoreList({ hubId, filters = [], pageNumber = 1, pageSize = 10_000, }) {
        const params = new QueryParameterBuilder()
            .addFilters(include('hubId', hubId))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addFields(field('code', 'name'));
        injectFilterParamHelper(params, filters);
        const response = await storeApi.getStoreList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async editStoreBasicInfo({ storeId = '', type, newData, }) {
        const formData = {
            ...newData,
        };
        if (formData.workingTime) {
            formData.workingTime = changeStartEndStringTimeZone(formData.workingTime, timeZoneCode.UTC);
        }
        const response = await storeApi.putStoreBasic(storeId, type, formData);
        return response.data;
    },
    async postStore(data) {
        const formData = {
            ...data,
        };
        if (formData.workingTime) {
            formData.workingTime = changeStartEndStringTimeZone(formData.workingTime, timeZoneCode.UTC);
        }
        const response = await storeApi.postStore(formData);
        return response.data;
    },
    // 상점 구간별 관리비 설정 (C,R,U,D)
    async postStoreManagementFeeBySection({ storeId, payload, }) {
        const { monthlyDeliveryStartCount, monthlyDeliveryEndCount, monthlyBasicFee, addCharge, } = payload;
        const data = {
            monthlyDeliveryStartCount,
            monthlyDeliveryEndCount,
            dailyLimitCount: 0, // 삭제 예정 key 값 https://barogo.slack.com/archives/C04UP4VFCKA/p1689149643454779
            monthlyBasicFee,
            addCharge,
        };
        const response = await storeApi.postStoreManagementFeeBySection(storeId, data);
        return response.data;
    },
    async getStoreManagementFeeBySection({ storeId, }) {
        const params = new QueryParameterBuilder()
            .build();
        const response = await storeApi.getStoreManagementFeeBySection(storeId, params);
        return response.data;
    },
    async putStoreManagementFeeBySection({ storeId, feeId, payload, }) {
        const { monthlyDeliveryStartCount, monthlyDeliveryEndCount, monthlyBasicFee, addCharge, } = payload;
        const data = {
            monthlyDeliveryStartCount,
            monthlyDeliveryEndCount,
            dailyLimitCount: 0, // 삭제 예정 key 값 https://barogo.slack.com/archives/C04UP4VFCKA/p1689149643454779
            monthlyBasicFee,
            addCharge,
        };
        const response = await storeApi.putStoreManagementFeeBySection(storeId, feeId, data);
        return response.data;
    },
    async deleteStoreManagementFeeBySection({ storeId, feeId, }) {
        const response = await storeApi.deleteStoreManagementFeeBySection(storeId, feeId);
        return response.data;
    },
    // 상품할증 설정 (C,R,U,D)
    async postStoreGoodsPriceSurchargeInfos({ storeId, payload, }) {
        const { orderAmountStart, orderAmountEnd, surcharge, surchargeRate, } = payload;
        const data = {
            orderAmountStart,
            orderAmountEnd,
            surcharge,
            surchargeRate,
        };
        const response = await storeApi.postStoreGoodsPriceSurchargeInfos(storeId, data);
        return response.data;
    },
    async getStoreGoodsPriceSurchargeInfos({ storeId, }) {
        const params = new QueryParameterBuilder()
            .build();
        const response = await storeApi.getStoreGoodsPriceSurchargeInfos(storeId, params);
        return response.data;
    },
    async putStoreGoodsPriceSurchargeInfos({ storeId, surchargeId, payload, }) {
        const { orderAmountStart, orderAmountEnd, surcharge, surchargeRate, } = payload;
        const data = {
            orderAmountStart,
            orderAmountEnd,
            surcharge,
            surchargeRate,
        };
        const response = await storeApi.putStoreGoodsPriceSurchargeInfos(storeId, surchargeId, data);
        return response.data;
    },
    async deleteStoreGoodsPriceSurchargeInfos({ storeId, surchargeId, }) {
        const response = await storeApi.deleteStoreGoodsPriceSurchargeInfos(storeId, surchargeId);
        return response.data;
    },
    async getStoreDeliveryPossibleAreaList({ storeId, }) {
        const pageNumber = 1;
        const pageSize = 10_000;
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .build();
        const response = await storeApi.getStoreDeliveryPossibleAreas(storeId, params);
        return response.data;
    },
    async postStoreDeliveryPossibleAreaList({ storeId, registers, unregisters, }) {
        const data = {
            registers,
            unregisters,
        };
        const response = await storeApi.postStoreDeliveryPossibleAreas(storeId, data);
        return response.data;
    },
    /**
     * 배달대행료 조회
     * https://qc-zoo-client-api.barogo.io/docs/api-guide.html#_6_25_%EC%83%81%EC%A0%90_%EA%B5%AC_%EB%B0%B0%EB%8B%AC%EB%8C%80%ED%96%89%EB%A3%8C_%EC%A1%B0%ED%9A%8C
     */
    async getDeliveryChargeList({ filters = [], pageNumber = 1, pageSize = 10_000, storeId, searchWord, }) {
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addSearchWord(searchWord);
        injectFilterParamHelper(params, filters);
        const response = await storeApi.getDeliveryChargeList(storeId, params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 배달대행료 삭제
     */
    async deleteDeliveryChargeList(serviceData) {
        const response = await storeApi.deleteDeliveryChargeList(serviceData.storeId, serviceData.createReqBody());
        return response.data;
    },
    /**
     * 배달대행료 추가
     */
    async postDeliveryCharge(serviceData) {
        const response = await storeApi.postDeliveryCharge(serviceData.storeId, serviceData.createReqBody());
        return response.data;
    },
    /**
     * 배달대행료 수정
     */
    async putDeliveryCharge(serviceData) {
        const response = await storeApi.putDeliveryCharge(serviceData.storeId, serviceData.reqBody.id, serviceData.createReqBody());
        return response.data;
    },
};
